/* eslint-disable @typescript-eslint/no-explicit-any */
import { timeZoneCityToCountry } from './time-zone-city-to-country';

export const handleOptionsSorting = (
  options: any,
  mostVisitedCountriesIds: any,
  userCountry: any
) => {
  const mostVisitedCountriesIdsArray = mostVisitedCountriesIds
    ? [...JSON.parse(mostVisitedCountriesIds as string)]
    : [];

  if (userCountry) {
    const userCountryIndex = options.findIndex(
      (option: any) => option?.label === userCountry
    );
    if (userCountryIndex !== -1) {
      const userCountryOption = options[userCountryIndex];

      const newOptions = options.filter(
        (option: any) => option?.label !== userCountry
      );
      newOptions.unshift(userCountryOption);
      return newOptions as readonly any[];
    }
  }

  if (mostVisitedCountriesIdsArray?.length > 0 && !userCountry) {
    const country = options?.find((option: any) => {
      return option?.ID === mostVisitedCountriesIdsArray?.[0];
    });

    if (country) {
      const newOptions = options.filter(
        (option: any) => option?.ID !== country?.ID
      );
      newOptions.unshift(country);
      return newOptions as readonly any[];
    }
  }

  if (mostVisitedCountriesIdsArray?.length === 0 && !userCountry) {
    let userCity;
    let userCountryFromTimeZone: string | undefined;
    let userTimeZone;

    if (Intl) {
      userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const tzArr = userTimeZone?.split('/');
      userCity = tzArr?.[tzArr?.length - 1];
      userCountryFromTimeZone = timeZoneCityToCountry?.[userCity];
    }

    if (userCountryFromTimeZone) {
      const country = options?.find(
        (option: any) => option?.label === userCountryFromTimeZone
      );
      if (country) {
        const newOptions = options.filter(
          (option: any) => option?.label !== country?.label
        );
        newOptions.unshift(country);
        return newOptions as readonly any[];
      }
    }
  }

  const mostVisitedCountry = options?.reduce(
    (prev: any, current: any) =>
      prev?.record_count > current?.record_count ? prev : current,
    null
  );

  if (mostVisitedCountry) {
    const newOptions = options.filter(
      (option: any) => option?.label !== mostVisitedCountry?.label
    );
    newOptions.unshift(mostVisitedCountry);
    return newOptions as readonly any[];
  }

  return options?.sort((a: any, b: any) => {
    if (a?.visited === b?.visited) {
      return 1;
    }
    return -1;
  }) as readonly any[];
};
